import { Modal } from 'react-bootstrap'
import { Option, Options } from './styles'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'
import { toast } from 'react-toastify'
import { useState } from 'react'
import WmsProductService from '../../../../services/database/WmsProductService'
import { CustomSpinner } from '../../../../components/CustomSpinner'
import { Center } from '../../../../components/Center'

export function ModalSelectProduct({
  isOpen,
  onClose,
  products,
  onSelectProduct,
}) {
  const [isLoadingAddresses, setIsLoadingAddresses] = useState(false)

  async function handleSelectProduct(product, index) {
    try {
      setIsLoadingAddresses((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      const addresses = await WmsProductService.getAddressesOfProduct(
        product.sku,
      )

      if (addresses.length === 0) {
        return toast.info(
          `Não foram encontrados endereços para ${product.descricao}!`,
        )
      }

      onSelectProduct({
        ...product,
        addresses,
      })
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível buscar os endereços do produto, tente novamente mais tarde!',
      )
    } finally {
      setIsLoadingAddresses((prevState) => ({
        ...prevState,
        [index]: false,
      }))

      onClose()
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size="lg"
      centered
    >
      <Modal.Header>
        <Modal.Title>Selecione o produto</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Options>
          {products.map((product, index) => (
            <Option onClick={() => handleSelectProduct(product, index)}>
              {isLoadingAddresses[index] ? (
                <Center>
                  <CustomSpinner size={18} />
                  <p>Buscnado endereço...</p>
                </Center>
              ) : (
                <p>
                  <strong>{product.sku}</strong> - {product.descricao}
                </p>
              )}
            </Option>
          ))}
        </Options>
      </Modal.Body>
    </Modal>
  )
}
